// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Proxima Nova';
  font-style: normal; }

.abstract-form {
  display: flex;
  flex-direction: column;
  padding-block: 30px 0; }
  .abstract-form .ant-select-selection-placeholder {
    font-weight: normal; }
  .abstract-form .btn-container {
    display: flex;
    justify-content: space-between;
    justify-content: flex-start;
    align-items: center;
    margin: 0px 42px 10px 0px; }
    .abstract-form .btn-container .expert-name {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left; }
      .abstract-form .btn-container .expert-name span {
        display: flex;
        align-items: center;
        margin-left: 8px;
        height: 25px;
        border-radius: 4px;
        font-family: 'Proxima Nova';
        font-size: 16px;
        font-weight: 600;
        line-height: 16px; }
  .abstract-form .container1 {
    display: flex; }
    .abstract-form .container1 .form-container {
      width: 100%; }
  .abstract-form .form-container::-webkit-scrollbar {
    width: 5px; }
  .abstract-form .form-container::-webkit-scrollbar-track {
    width: 10px;
    background: #fff; }
  .abstract-form .form-container::-webkit-scrollbar-thumb {
    height: 433px;
    background: #cdd7e0; }
  .abstract-form .form-container::-webkit-scrollbar-thumb:hover {
    background: #555; }
  .abstract-form .ant-select-arrow {
    color: #323232; }

.publish-btn-container {
  display: flex;
  column-gap: 10px; }

.publish-btn .ant-btn {
  background: #586f80;
  border-radius: 2px;
  height: 32px;
  width: 95px;
  color: white;
  font-weight: 600;
  text-align: center;
  transition: all 0.5s linear;
  border: none !important; }
  .publish-btn .ant-btn:hover, .publish-btn .ant-btn:focus {
    color: white;
    background: #586f80;
    border: none; }

.ant-btn .ant-btn-primary {
  position: absolute;
  top: 81px;
  right: 16px; }

/**
* if the following code is uncommented, the asterisk for required field will not be shown
.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    content: '' !important;
    margin-right: 0 !important;
}

* if uncommented, the colon after the label in a form field will be hidden
.ant-form-item-label > label::after {
    content: '' !important;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
    content: '' !important;
}
*/
.textArea {
  flex-direction: column !important; }

.textAreaInput {
  width: 566px !important; }

.ant-form-item textarea.ant-input {
  max-width: 566px !important;
  min-height: 109px !important;
  padding: 12px 9px; }

.upload {
  flex-direction: column !important; }
  .upload .label-paragraph {
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    width: max-content; }

.ant-form-item-label > label {
  font-size: 16px !important; }

.checkbox1 {
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 300 !important;
  font-size: 16px;
  display: flex;
  align-items: flex-start; }
  .checkbox1 span {
    line-height: 14px; }

.upload-container {
  width: 566px; }

.ant-upload.ant-upload-drag {
  margin-bottom: 12px; }

.tags .ant-tag-checkable-checked {
  background-color: #586f80;
  color: #fff !important; }

.tags .ant-tag {
  border-radius: 50px;
  padding: 6.4px 15px;
  border: 1px solid #586f80 !important;
  color: #323232;
  font-size: 14px;
  font-weight: normal;
  margin: 0 24px 15px 0;
  width: -moz-fit-content;
  width: fit-content; }
  .tags .ant-tag:hover {
    color: #f8fafb !important;
    background-color: #586f80 !important; }

.addField-btn {
  margin-top: -10px !important; }
  .addField-btn button {
    padding-left: 0;
    padding-top: 0;
    font-weight: 600;
    font-size: 16px;
    color: #637f92; }
  .addField-btn .ant-btn {
    border: none; }
    .addField-btn .ant-btn:active, .addField-btn .ant-btn:hover, .addField-btn .ant-btn:focus {
      color: #586f80 !important; }
  .addField-btn .ant-btn-block {
    width: 0%; }

.addField-input .ant-input {
  width: 566px !important; }

.ant-input {
  color: #323232 !important; }

.ant-select-selection-item {
  font-weight: normal; }

.ant-select-selector:hover,
.ant-select-selector:focus-within {
  border: 1px solid #586f80 !important;
  box-shadow: none !important; }

.delete-question {
  margin-top: 9px;
  margin-left: 8px;
  height: 13px;
  cursor: pointer; }

.tags-wrapper {
  display: grid;
  grid-template-columns: auto auto auto; }

.addField-input-wrapper .ant-row {
  width: 566px; }

/** is it required to overwrite the library colors using important?
.ant-input:focus,
.ant-input-focused,
.ant-input:hover,
.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
.ant-input-affix-wrapper:focus {
    border-color: #586f80 !important;
    box-shadow: none !important;
}

.ant-picker:hover,
.ant-picker-focused,
.ant-picker-hover,
.ant-picker-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
.ant-picker-affix-wrapper:focus {
    border-color: #586f80 !important;
    box-shadow: none !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
    background-color: #586f80 !important;
    border-color: #586f58 !important;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #586f58 !important;
}
*/
.nested-checkbox-input {
  align-items: center;
  justify-content: space-around;
  height: 104px;
  padding: 32px !important;
  background: rgba(240, 244, 247, 0.4); }

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  height: 350px; }

.ql-editor {
  overflow-y: scroll;
  resize: vertical; }

.card {
  width: 705px;
  min-height: 250px;
  background: rgba(240, 244, 247, 0.4) !important;
  border: none !important;
  margin-bottom: 28px !important; }
  .card .ant-card-body .ant-row {
    align-items: flex-start; }
  .card .ant-card-head-title {
    font-size: 16px; }
  .card .card-content .ant-col .ant-col-8 .ant-form-item-label {
    width: 329px; }
  .card .ant-card-body {
    padding: 24px 0px 24px 20px; }
  .card .card-content div {
    width: 355px;
    display: flex;
    justify-content: space-between;
    align-items: center; }
  .card .ant-col-8 {
    flex: none;
    max-width: 45%; }

.option-card {
  border: none !important; }
  .option-card .ant-form-item-explain-error {
    position: absolute;
    left: -260px; }
  .option-card .ant-card-head-title {
    position: relative;
    right: 23px;
    font-size: 16px;
    font-weight: 600; }
  .option-card .option-card-checkbox {
    position: relative;
    right: 286px; }
  .option-card .ant-col-8 {
    flex: none;
    max-width: 46%; }

.table .ant-form-item-label {
  display: none; }

.table .ant-form-item-control {
  max-width: 100%; }
  .table .ant-form-item-control .ant-form-item-control-input-content {
    max-width: 100% !important; }
  .table .ant-form-item-control > .table-btn-container {
    margin-top: 0; }

.checkboxGroupContainer {
  display: grid;
  grid-template-columns: 45% 55%;
  column-gap: 10px; }
`, "",{"version":3,"sources":["webpack://./src/pages/Entity/AbstractForm/style.scss"],"names":[],"mappings":"AAAA;EACI,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB,EAAA;;AAGtB;EACI,aAAa;EACb,sBAAsB;EACtB,qBAAqB,EAAA;EAHzB;IAMQ,mBAAmB,EAAA;EAN3B;IAUQ,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB,EAAA;IAdjC;MAiBY,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB;MACnB,gBAAgB,EAAA;MAvB5B;QA0BgB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,2BAA2B;QAC3B,eAAe;QACf,gBAAgB;QAChB,iBAAiB,EAAA;EAlCjC;IAwCQ,aAAa,EAAA;IAxCrB;MA2CY,WAAW,EAAA;EA3CvB;IAgDQ,UAAU,EAAA;EAhDlB;IAoDQ,WAAW;IACX,gBAAgB,EAAA;EArDxB;IAyDQ,aAAa;IACb,mBAAmB,EAAA;EA1D3B;IA8DQ,gBAAgB,EAAA;EA9DxB;IAkEQ,cAAc,EAAA;;AAItB;EACI,aAAa;EACb,gBAAgB,EAAA;;AAGpB;EAEQ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB,EAAA;EAV/B;IAcY,YAAY;IACZ,mBAAmB;IACnB,YAAY,EAAA;;AAKxB;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAA;;AAQf;;;;;;;;;;;;;;;CAtBC;AAuCD;EACI,iCAAiC,EAAA;;AAGrC;EACI,uBAAuB,EAAA;;AAG3B;EACI,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB,EAAA;;AAGrB;EACI,iCAAiC,EAAA;EADrC;IAIQ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB,EAAA;;AAI1B;EACI,0BAA0B,EAAA;;AAG9B;EACI,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,uBAAuB,EAAA;EAN3B;IASQ,iBAAiB,EAAA;;AAIzB;EACI,YAAY,EAAA;;AAGhB;EACI,mBAAmB,EAAA;;AAGvB;EAEQ,yBAAyB;EACzB,sBAAsB,EAAA;;AAH9B;EAOQ,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB,EAAA;EAd1B;IAiBY,yBAAyB;IACzB,oCAAoC,EAAA;;AAKhD;EACI,4BAA4B,EAAA;EADhC;IAIQ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAA;EARtB;IAYQ,YAAY,EAAA;IAZpB;MAiBY,yBAAyB,EAAA;EAjBrC;IAsBQ,SAAS,EAAA;;AAIjB;EACI,uBAAuB,EAAA;;AAG3B;EACI,yBAAyB,EAAA;;AAG7B;EACI,mBAAmB,EAAA;;AAGvB;;EAEI,oCAAoC;EACpC,2BAA2B,EAAA;;AAG/B;EACI,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe,EAAA;;AAGnB;EACI,aAAa;EACb,qCAAqC,EAAA;;AAGzC;EACI,YAAY,EAAA;;AAGhB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA7CC;AA4ED;EACI,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;EACxB,oCAAoC,EAAA;;AAIxC;EACI,eAAe;EACf,aAAa,EAAA;;AAGjB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;;AAGpB;EACI,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;EAC/C,uBAAuB;EACvB,8BAA8B,EAAA;EALlC;IASY,uBAAuB,EAAA;EATnC;IAcQ,eAAe,EAAA;EAdvB;IAkBY,YAAY,EAAA;EAlBxB;IAuBQ,2BAA2B,EAAA;EAvBnC;IA2BQ,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;EA9B3B;IAkCQ,UAAU;IACV,cAAc,EAAA;;AAItB;EACI,uBAAuB,EAAA;EAD3B;IAIQ,kBAAkB;IAClB,YAAY,EAAA;EALpB;IASQ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB,EAAA;EAZxB;IAgBQ,kBAAkB;IAClB,YAAY,EAAA;EAjBpB;IAqBQ,UAAU;IACV,cAAc,EAAA;;AAItB;EAEQ,aAAa,EAAA;;AAFrB;EAMQ,eAAe,EAAA;EANvB;IASY,0BAA0B,EAAA;EATtC;IAaY,aAAa,EAAA;;AAKzB;EACI,aAAa;EACb,8BAA8B;EAC9B,gBAAgB,EAAA","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'Proxima Nova';\n    font-style: normal;\n}\n\n.abstract-form {\n    display: flex;\n    flex-direction: column;\n    padding-block: 30px 0;\n\n    .ant-select-selection-placeholder {\n        font-weight: normal;\n    }\n\n    .btn-container {\n        display: flex;\n        justify-content: space-between;\n        justify-content: flex-start;\n        align-items: center;\n        margin: 0px 42px 10px 0px;\n\n        .expert-name {\n            display: flex;\n            align-items: center;\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 24px;\n            letter-spacing: 0px;\n            text-align: left;\n\n            span {\n                display: flex;\n                align-items: center;\n                margin-left: 8px;\n                height: 25px;\n                border-radius: 4px;\n                font-family: 'Proxima Nova';\n                font-size: 16px;\n                font-weight: 600;\n                line-height: 16px;\n            }\n        }\n    }\n\n    .container1 {\n        display: flex;\n\n        .form-container {\n            width: 100%;\n        }\n    }\n\n    .form-container::-webkit-scrollbar {\n        width: 5px;\n    }\n\n    .form-container::-webkit-scrollbar-track {\n        width: 10px;\n        background: #fff;\n    }\n\n    .form-container::-webkit-scrollbar-thumb {\n        height: 433px;\n        background: #cdd7e0;\n    }\n\n    .form-container::-webkit-scrollbar-thumb:hover {\n        background: #555;\n    }\n\n    .ant-select-arrow {\n        color: #323232;\n    }\n}\n\n.publish-btn-container {\n    display: flex;\n    column-gap: 10px;\n}\n\n.publish-btn {\n    .ant-btn {\n        background: #586f80;\n        border-radius: 2px;\n        height: 32px;\n        width: 95px;\n        color: white;\n        font-weight: 600;\n        text-align: center;\n        transition: all 0.5s linear;\n        border: none !important;\n\n        &:hover,\n        &:focus {\n            color: white;\n            background: #586f80;\n            border: none;\n        }\n    }\n}\n\n.ant-btn .ant-btn-primary {\n    position: absolute;\n    top: 81px;\n    right: 16px;\n}\n\n.ant-form-horizontal .ant-form-item-label {\n    // this aligns the labels of the form field to the left which are by default set to right\n    // text-align: left;\n}\n\n/**\n* if the following code is uncommented, the asterisk for required field will not be shown\n.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n    content: '' !important;\n    margin-right: 0 !important;\n}\n\n* if uncommented, the colon after the label in a form field will be hidden\n.ant-form-item-label > label::after {\n    content: '' !important;\n}\n\n.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n    content: '' !important;\n}\n*/\n\n.textArea {\n    flex-direction: column !important;\n}\n\n.textAreaInput {\n    width: 566px !important;\n}\n\n.ant-form-item textarea.ant-input {\n    max-width: 566px !important;\n    min-height: 109px !important;\n    padding: 12px 9px;\n}\n\n.upload {\n    flex-direction: column !important;\n\n    .label-paragraph {\n        margin-bottom: 12px;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 17px;\n        width: max-content;\n    }\n}\n\n.ant-form-item-label > label {\n    font-size: 16px !important;\n}\n\n.checkbox1 {\n    font-family: 'Proxima Nova';\n    font-style: normal;\n    font-weight: 300 !important;\n    font-size: 16px;\n    display: flex;\n    align-items: flex-start;\n\n    span {\n        line-height: 14px;\n    }\n}\n\n.upload-container {\n    width: 566px;\n}\n\n.ant-upload.ant-upload-drag {\n    margin-bottom: 12px;\n}\n\n.tags {\n    .ant-tag-checkable-checked {\n        background-color: #586f80;\n        color: #fff !important;\n    }\n\n    .ant-tag {\n        border-radius: 50px;\n        padding: 6.4px 15px;\n        border: 1px solid #586f80 !important;\n        color: #323232;\n        font-size: 14px;\n        font-weight: normal;\n        margin: 0 24px 15px 0;\n        width: fit-content;\n\n        &:hover {\n            color: #f8fafb !important;\n            background-color: #586f80 !important;\n        }\n    }\n}\n\n.addField-btn {\n    margin-top: -10px !important;\n\n    button {\n        padding-left: 0;\n        padding-top: 0;\n        font-weight: 600;\n        font-size: 16px;\n        color: #637f92;\n    }\n\n    .ant-btn {\n        border: none;\n\n        &:active,\n        &:hover,\n        &:focus {\n            color: #586f80 !important;\n        }\n    }\n\n    .ant-btn-block {\n        width: 0%;\n    }\n}\n\n.addField-input .ant-input {\n    width: 566px !important;\n}\n\n.ant-input {\n    color: #323232 !important;\n}\n\n.ant-select-selection-item {\n    font-weight: normal;\n}\n\n.ant-select-selector:hover,\n.ant-select-selector:focus-within {\n    border: 1px solid #586f80 !important;\n    box-shadow: none !important;\n}\n\n.delete-question {\n    margin-top: 9px;\n    margin-left: 8px;\n    height: 13px;\n    cursor: pointer;\n}\n\n.tags-wrapper {\n    display: grid;\n    grid-template-columns: auto auto auto;\n}\n\n.addField-input-wrapper .ant-row {\n    width: 566px;\n}\n\n/** is it required to overwrite the library colors using important?\n.ant-input:focus,\n.ant-input-focused,\n.ant-input:hover,\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,\n.ant-input-affix-wrapper:focus {\n    border-color: #586f80 !important;\n    box-shadow: none !important;\n}\n\n.ant-picker:hover,\n.ant-picker-focused,\n.ant-picker-hover,\n.ant-picker-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,\n.ant-picker-affix-wrapper:focus {\n    border-color: #586f80 !important;\n    box-shadow: none !important;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n    background-color: #586f80 !important;\n    border-color: #586f58 !important;\n}\n\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #586f58 !important;\n}\n*/\n\n.nested-checkbox-input {\n    align-items: center;\n    justify-content: space-around;\n    height: 104px;\n    padding: 32px !important;\n    background: rgba(240, 244, 247, 0.4);\n}\n\n// this is textEditor style\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\n    border-top: 0px;\n    height: 350px;\n}\n\n.ql-editor {\n    overflow-y: scroll;\n    resize: vertical;\n}\n\n.card {\n    width: 705px;\n    min-height: 250px;\n    background: rgba(240, 244, 247, 0.4) !important;\n    border: none !important;\n    margin-bottom: 28px !important;\n\n    .ant-card-body {\n        .ant-row {\n            align-items: flex-start;\n        }\n    }\n\n    .ant-card-head-title {\n        font-size: 16px;\n    }\n    .card-content {\n        .ant-col .ant-col-8 .ant-form-item-label {\n            width: 329px;\n        }\n    }\n\n    .ant-card-body {\n        padding: 24px 0px 24px 20px;\n    }\n\n    .card-content div {\n        width: 355px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .ant-col-8 {\n        flex: none;\n        max-width: 45%;\n    }\n}\n\n.option-card {\n    border: none !important;\n\n    .ant-form-item-explain-error {\n        position: absolute;\n        left: -260px;\n    }\n\n    .ant-card-head-title {\n        position: relative;\n        right: 23px;\n        font-size: 16px;\n        font-weight: 600;\n    }\n\n    .option-card-checkbox {\n        position: relative;\n        right: 286px;\n    }\n\n    .ant-col-8 {\n        flex: none;\n        max-width: 46%;\n    }\n}\n\n.table {\n    .ant-form-item-label {\n        display: none;\n    }\n\n    .ant-form-item-control {\n        max-width: 100%;\n\n        .ant-form-item-control-input-content {\n            max-width: 100% !important;\n        }\n\n        & > .table-btn-container {\n            margin-top: 0;\n        }\n    }\n}\n\n.checkboxGroupContainer {\n    display: grid;\n    grid-template-columns: 45% 55%;\n    column-gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
